/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_3_DescInputs */

const es_home_features_item_3_desc = /** @type {(inputs: Home_Features_Item_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados en segundos, no minutos de navegación por carpetas.`)
};

const en_home_features_item_3_desc = /** @type {(inputs: Home_Features_Item_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results in seconds, not minutes of browsing through folders.`)
};

/**
* | output |
* | --- |
* | "Results in seconds, not minutes of browsing through folders." |
*
* @param {Home_Features_Item_3_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_3_desc = /** @type {((inputs?: Home_Features_Item_3_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_3_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_3_desc(inputs)
	return en_home_features_item_3_desc(inputs)
});
export { home_features_item_3_desc as "home.features.item_3_desc" }